var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIron = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M7.667 24.414c-.16.272-.207.452-.132.602.18.353.992.769 1.623.859 3.51.5 12.355.749 16.401.564.004 0 2.702-.067 2.702-.63 0-.26-.279-.534-.773-.81M16.5 15.694v-1.242s-.036-.742.96-.989h3.388"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M7.643 24.336c-.125-.247.174-.558.672-1.238 2.258-3.082 10.165-11.006 19.501-11.075.31-.003.658.015.854.085.221.08.276.115.44.422.835 1.563 2.674 6.47 3.259 8.857.188.768.156.88.018 1.075-.256.36-.552.376-1.229.529-.697.157-1.451.346-2.434.728-.988.384-20.903.97-21.081.617Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M26.194 25.501c1.497-.1 1.542-1.398 2.53-1.783M18.986 16.569c2.165-1.463 4.855-2.632 7.758-2.69.33-.007.732.127.83.326.387.783.71 1.838.853 2.478.112.496-.342.932-.777 1.029-.447.1-5.26 1.528-8.442 2.316-.894.22-1.691-.41-1.851-1.138-.185-.836.4-1.49 1.629-2.321Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "m23.34 18.865-.13-.96a.36.36 0 0 0-.445-.25l-2.948.816a.357.357 0 0 0-.25.441l.145.967M32.085 20.35l-17.393 2.203c-.786.195-1.376.68-1.376.68l-.962 1.195"
}))));
export default SvgIron;